import Vue from 'vue'
import {
  Swipe,
  SwipeItem,
  Image,
  Button,
  Cell,
  CellGroup,
  Stepper,
  Field,
  Divider,
  Lazyload,
  RadioGroup,
  Radio,
  Toast,
  NumberKeyboard,
  Icon,
  Dialog,
  Loading,
  Popup
} from 'vant'
import 'vant/lib/index.css'
Vue.prototype.$toast = Toast
Vue.prototype.$dialog = Dialog
Vue.use(Swipe)
  .use(SwipeItem)
  .use(Image)
  .use(Button)
  .use(Cell)
  .use(CellGroup)
  .use(Stepper)
  .use(Field)
  .use(Divider)
  .use(Lazyload)
  .use(RadioGroup)
  .use(Radio)
  .use(Toast)
  .use(NumberKeyboard)
  .use(Icon)
  .use(Dialog)
  .use(Loading)
  .use(Popup)
